module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-ExtraLight.f3beb095.ttf";